module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetHigh@2x.867849a.webp";